import SkillLevelTable from './SkillLevelTable';

export default SkillLevelTable;
